{
  "theme": {
    "dark": "Tema escuro",
    "main": "Tema principal"
  },
  "projectCustomisation": {
    "projectDetails": "Detalhes do projeto",
    "editDetails": "Editar detalhes",
    "projectName": "Nome do projeto",
    "projectNameHelperText": "Máximo de 24 caracteres",
    "projectLogoTitle": "Logotipo do projeto",
    "projectLogoHint": "Essa imagem será mostrada na barra de navegação superior e na página de login do projeto",
    "projectLogoRemoveTitle": "Remover a imagem do logotipo deste projeto",
    "projectLogoRemoveText": "Isso removerá o arquivo de imagem do logotipo e todos com acesso ao projeto não o verão mais. Tem certeza de que deseja continuar?",
    "projectLogoRestrictionHint": "O tamanho máximo da imagem é 1920px (altura) e 1080px (largura)",
    "projectImageTitle": "Imagem do projeto",
    "projectImageHint": "Essa imagem será mostrada no cartão e no painel do projeto",
    "projectImageRemoveTitle": "Remover a imagem deste projeto",
    "projectImageRemoveText": "Isso removerá o arquivo de imagem e todos com acesso ao projeto não o verão mais. Tem certeza de que deseja continuar?",
    "projectImageRestrictionHint": "O tamanho máximo da imagem é 1920px (altura) e 1080px (largura)"
  },
  "scheduleConfig": {
    "title": "Configuração do cronograma",
    "description": "A programação pode ser configurada usando as configurações abaixo. Faça alterações aqui somente se você tiver uma compreensão detalhada de como a configuração do cronograma funciona. Se você não tiver certeza, entre em contato com o suporte da Iventis:",
    "save": "Salvar alterações no cronograma",
    "timesAndDates": "Horários e datas",
    "venueTypeHierarchy": "Hierarquia de tipos de locais",
    "scheduleVersionHierarchy": "Hierarquia de versões do cronograma",
    "eventBlockHierarchy": "Hierarquia de blocos de eventos",
    "venueRunSheets": "Planilhas de execução do local (DCAS)",
    "timezone": "Fuso horário",
    "dayStartTime": "Hora de início de cada dia",
    "dayEndTime": "Hora de término de cada dia",
    "projectStartDate": "Data de início do projeto",
    "projectEndDate": "Data de término do projeto",
    "projectZeroDate": "Dia 0 do projeto",
    "eventBlockTitleTop": "Blocos de eventos do calendário de nível superior",
    "eventBlockTitleSecond": "Blocos de eventos do calendário de segundo nível",
    "eventBlockTitleThird": "Bloco de eventos do calendário de terceiro nível",
    "eventBlockTitleDefault": "Bloco de eventos do calendário de níveis",
    "eventBlockTypeName": "Nome do tipo de bloco de eventos",
    "eventBlockApiSingle": "Nome da API singular",
    "eventBlockApiPlural": "Nome da API plural",
    "eventBlockAllowedVenueTypes": "Tipos de locais permitidos",
    "eventBlockRelativeTypes": "Pode ser relativo aos tipos",
    "eventBlockSummaryText": "Atributos do bloco de eventos infantis a serem usados no resumo",
    "eventBlockDCAS": "Pode ser criado dentro do DCAS",
    "eventBlockCustomerIdentifier": "Identificador do cliente",
    "clusterVenueLocationTemplateTitle": "Modelo de localização do local do cluster",
    "mainVenueLocationTemplateTitle": "Modelo de localização do local principal",
    "subVenueLocationTemplateTitle": "Modelo de localização do sublocal",
    "enableClusters": "Habilitar clusters",
    "editVenues": "Editar locais",
    "venueLocations": "Localizações dos locais",
    "venueLocationTypeName": "Nome do tipo de localização do local",
    "attributes": "Atributos",
    "scheduleVersionTopLevelTitle": "Versão de programação de nível superior",
    "scheduleVersionSecondLevelTitle": "Versão de programação de segundo nível",
    "scheduleVersionLevelTitle": "Versão do cronograma de níveis",
    "scheduleVersionName": "Nome da versão do cronograma",
    "problems": "Há {{ problemCount }} problemas com a configuração do cronograma enviado",
    "dcasEventBlock": "Bloco de eventos para Run Sheet",
    "dcasEventBlockQuestion": "Ativar bloco de eventos somente da planilha de execução",
    "dcasEventBlockCalendar": "Blocos de eventos para usar",
    "dcasEventBlockAttributes": "Atributos para Run Sheet",
    "dcasEnableDone": "Marque as atividades com “Concluído”",
    "calendarLevel": {
      "0": "sessão",
      "1": "item agendado",
      "activity": "atividade"
    }
  }
}